module.exports = __webpack_public_path__ + "static/media/NavWalletIcon.b246e8c1.svg";